import { RouteInfo } from './vertical-menu.metadata';

export interface MenuPermissionSource {
  isClientUser(): boolean;
  isOnboardingOnlyUser(): boolean;
  hasAnyPrivilege(codes: string[]): boolean;
}

export function filterVisibleRoutes(routes: RouteInfo[], permissions: MenuPermissionSource): RouteInfo[] {
  const isClientUser = permissions.isClientUser();
  const isOnboardingOnlyUser = permissions.isOnboardingOnlyUser();

  return routes.reduce<RouteInfo[]>((visible, route) => {
    if (isOnboardingOnlyUser && route.audience !== 'onboarding') {
      return visible;
    }
    if (route.audience === 'portal' && (!isClientUser || isOnboardingOnlyUser)) {
      return visible;
    }
    if (route.audience === 'admin' && (isClientUser || isOnboardingOnlyUser)) {
      return visible;
    }
    if (route.audience === 'onboarding' && !isOnboardingOnlyUser) {
      return visible;
    }
    if (route.requiredPrivileges?.length && !permissions.hasAnyPrivilege(route.requiredPrivileges)) {
      return visible;
    }

    if (route.submenu?.length) {
      const visibleSubmenu = filterVisibleRoutes(route.submenu, permissions);
      if (!visibleSubmenu.length) {
        return visible;
      }
      visible.push({ ...route, submenu: visibleSubmenu });
      return visible;
    }

    visible.push(route);
    return visible;
  }, []);
}
